// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/region-wages",
  Create: "/pyr/region-wages",
  Update: "/pyr/region-wages",
};
